import { render, staticRenderFns } from "./SubmissionLogsToolbar.vue?vue&type=template&id=1ff0be7b&"
import script from "./SubmissionLogsToolbar.vue?vue&type=script&lang=js&"
export * from "./SubmissionLogsToolbar.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionLogsToolbar.vue?vue&type=style&index=0&id=1ff0be7b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports